import IconMenu from '@BUP/components/IconMenu'
import Rbac from '@BUP/components/RBAC'
import { isSociogram } from '@BUP/services/BraveUp'
import { NavLink } from 'react-router-dom'
import WorkGroupSubNavLink from './work-group-sub-nav-link'
import styles from '../GenericNavigation/generic-navigation.module.scss'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useGetCurrentSociogram } from '@BUP/hooks/Sociogram/useGetCurrentSociogram'
import BupSpinner from '@BUP/components/Loading/Spinner'

const DataNavLink = ({ organization, isMainTeacher }) => {
  const i18n = useTranslation()
  const { dataCurrentSociogram, isLoadingCurrentSociogram, errorCurrentSociogram } = useGetCurrentSociogram()
  const getNavLinkClassName = ({ isActive }) =>
    classNames(styles.nav_link, { [styles.active]: isActive, active: isActive })
  const getSubNavLinkClassName = ({ isActive }) =>
    classNames(styles.sub_nav_link, { [styles.active]: isActive, active: isActive })
  if (isLoadingCurrentSociogram) return <BupSpinner size='small' revert />
  if (errorCurrentSociogram) return null

  return (
    <div className={styles.element_wrapper}>
      <NavLink
        to='/data'
        className={getNavLinkClassName}
      >
        <IconMenu iconName='data' />
        <span className={styles.nav_label}>{i18n.t('nav.data')}</span>
        <span className={styles.nav_label_mobile}>
          {i18n.t('nav.dataMobile')}
        </span>
      </NavLink>
      {dataCurrentSociogram && dataCurrentSociogram.currentSociogram && isSociogram(organization) && (
        <Rbac name='navSociogram'>
          <ul>
            {isMainTeacher && (
              <li>
                <NavLink
                  to='/sociogram'
                  className={getSubNavLinkClassName}
                >
                  <span className={styles.nav_label}>{i18n.t('nav.sociogram')}</span>
                </NavLink>
              </li>)}
            <li>
              <WorkGroupSubNavLink />
            </li>
          </ul>
        </Rbac>)}
    </div>
  )
}

export default DataNavLink
